<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Country Support Overview
      <b-button slot="right" type="is-primary" @click="$router.go(-1)">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <country-support-overview />
    </section>
  </div>
</template>

<script>
import CountrySupportOverview from "@/components/Reportingtracker/CountrySupportOverview";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";

export default {
  name: "ReportingTracker",
  components: { HeroBar, TitleBar, CountrySupportOverview },
  computed: {
    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        {
          url: "/reportingTracker/country-overview",
          name: "Country Support Overview"
        }
      ];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  }
};
</script>
